/**
 * @generated SignedSource<<213658e54018e63b6b5cbd19c9d36d3c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type AIGenerationReferenceStatus = "completed" | "failed" | "pending" | "%future added value";
export type AIGenerationStatus = "completed" | "draft" | "failed" | "pending" | "running" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CurriculumOutlineContentFragment$data = {
  readonly id: string;
  readonly input: {
    readonly searchWeb: boolean | null;
  };
  readonly references: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly status: AIGenerationReferenceStatus;
      };
    }>;
  };
  readonly status: AIGenerationStatus;
  readonly " $fragmentType": "CurriculumOutlineContentFragment";
};
export type CurriculumOutlineContentFragment$key = {
  readonly " $data"?: CurriculumOutlineContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CurriculumOutlineContentFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurriculumOutlineContentFragment",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AIGenerationInput",
      "kind": "LinkedField",
      "name": "input",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "searchWeb",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AIGenerationReferenceNodeConnection",
      "kind": "LinkedField",
      "name": "references",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AIGenerationReferenceNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AIGenerationReference",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AIGeneration",
  "abstractKey": null
};
})();

(node as any).hash = "81499e2d8771275592ff1e9969eab781";

export default node;
